import { VITE_USE_MOCK, VITE_MOCK_API, VITE_TOKENIZATION_API } from 'Constants/appEnvConstants'

export function getTokenizeBaseUrl() {
  // eslint-disable-next-line no-undef
  return JSON.parse(VITE_USE_MOCK) ? VITE_MOCK_API : VITE_TOKENIZATION_API;
}

export default {
  getTokenizeBaseUrl,
};
